export const register = {
    title: 'SIGN UP',
    storeId: {
        name: 'Store ID',
        placeholder: '',
        required: 'Please enter store ID',
        too_short: '',
        invalid: '',
    },
    storeName: {
        name: 'Store Name',
        placeholder: '',
        required: 'Please enter store Name',
        too_short: '',
        invalid: '',
    },
    firstname: {
        name: 'Firstname',
        placeholder: '',
        required: 'Please enter firstname',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'Lastname',
        placeholder: '',
        required: 'Please enter lastname',
        too_short: '',
        invalid: '',
    },
    mobileNumber: {
        name: 'Mobile Phone Number',
        placeholder: '',
        required: 'Please enter mobile phone number',
        too_short: '',
        invalid: 'The  mobile phone number is incorrect.',
    },
    email: {
        name: 'Email',
        placeholder: '',
        required: '',
        too_short: '',
        invalid: 'The email address is incorrect.',
    },
    username: {
        name: 'Username',
        placeholder: '',
        required: 'Please enter username',
        too_short: '',
        invalid: '',
    },
    password: {
        name: 'Password',
        placeholder: '',
        required: 'Please enter your password with at least 8 characters contains a-z, A-Z, or 0-9. ',
        too_short: 'Please enter your password with at least 8 characters contains a-z, A-Z, or 0-9. ',
        invalid: 'The password format  is incorrect.',
    },
    confirmPassword: {
        name: 'Confirm Password',
        placeholder: '',
        required: 'Please enter your password  with at least 8 characters contains a-z, A-Z, or 0-9. ',
        too_short: 'Please enter your password  with at least 8 characters contains a-z, A-Z, or 0-9. ',
        invalid: 'Passwords don’t match.',
    },
    storeType_title: 'Store Type',
    storeType_err : '(Please select at least one type of shop.)',
    storeType: {
        StoreID: '',
        StoreName: '',
        StoreType: []
    },
    create_new_password: 'CREATE NEW PASSWORD',
    confirm_new_password: {
        title: 'Confirm?',
        msg: 'Did you confirm creating a new password?'
    },
    password_not_match: 'Passwords don’t match.',
    change_password: {
        succress: {
            title: 'Successfully!',
            msg: 'Your password has been changed successfully.Please use a new password to log in',
            btn: 'Login now!'
        },
        error_otp: {
            title: 'Warning!',
            msg: 'Information is not found.'
        }
    },
    btn_register: 'Sign Up',
    is_own_shop: 'Own a shop/have a shop'
};
